import { FullStory, init, isInitialized } from '@fullstory/browser';

import configuration from '@atom/utilities/configuration';

export const instantiateFullStory = () => {
  init({
    orgId: 'G642N',
    devMode: configuration.environment !== 'production',
  });
};

// Errors caught by error boundary (errorElement or ErrorBoundary) will be
// logged to FullStory as Render Error now to improve visibility.
export const reportRenderError = (error: unknown, source: string) => {
  if (!isInitialized()) {
    return;
  }

  FullStory('trackEvent', {
    name: 'Render Error',
    properties: {
      source,
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? (error.stack ?? '') : '',
      url: window.location.href,
    },
  });
};
